// Distance helpers for the locations overview (#281). Everything is computed in
// the browser: no position is sent to the API.

const EARTH_RADIUS_KM = 6371

// Normalise {lat, lng} (numbers or numeric strings) to numbers, or null.
export function toLatLng(coordinates) {
  if (!coordinates) return null
  const lat = Number(coordinates.lat)
  const lng = Number(coordinates.lng)
  if (
    coordinates.lat === null ||
    coordinates.lng === null ||
    coordinates.lat === '' ||
    coordinates.lng === '' ||
    !Number.isFinite(lat) ||
    !Number.isFinite(lng)
  ) {
    return null
  }
  return { lat, lng }
}

// Great-circle (haversine) distance in km between two coordinates, or null
// when either is missing.
export function distanceKm(from, to) {
  const a = toLatLng(from)
  const b = toLatLng(to)
  if (!a || !b) return null
  const rad = (deg) => (deg * Math.PI) / 180
  const dLat = rad(b.lat - a.lat)
  const dLng = rad(b.lng - a.lng)
  const h =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(rad(a.lat)) * Math.cos(rad(b.lat)) * Math.sin(dLng / 2) ** 2
  return 2 * EARTH_RADIUS_KM * Math.asin(Math.min(1, Math.sqrt(h)))
}

// "3,2 km" (Dutch decimal comma, one decimal)
export function formatDistance(km) {
  if (km === null || km === undefined || !Number.isFinite(km)) return ''
  return `${km.toFixed(1).replace('.', ',')} km`
}

// Sort items nearest first by the distance getDistance(item) returns; items
// without a distance go last, in their original order.
export function sortByDistance(items, getDistance) {
  return items
    .map((item, index) => ({ item, index, km: getDistance(item) }))
    .sort((a, b) => {
      const aMissing = a.km === null || a.km === undefined
      const bMissing = b.km === null || b.km === undefined
      if (aMissing || bMissing) {
        return aMissing === bMissing ? a.index - b.index : aMissing ? 1 : -1
      }
      return a.km - b.km || a.index - b.index
    })
    .map(({ item }) => item)
}
